const GT_URL = 'general-trade/';
const INFO_URL = `${GT_URL}info/`;
const BUKAPOLY_URL = `${GT_URL}bukapoly-codes/`;

export const getAddress = $axios => $axios.$get(`${GT_URL}addresses`);
export const addAddress = ($axios, payload) => $axios.$post(`${GT_URL}addresses`, payload);
export const updateAddress = ($axios, payload) => $axios.$patch(`${GT_URL}addresses/${payload.id}`, payload);
export const getProvince = $axios => $axios.$get(`${INFO_URL}provinces`);
export const getCity = ($axios, province) => $axios.$get(`${INFO_URL}cities`, { params: { province } });
export const getArea = ($axios, province, city) => $axios.$get(`${INFO_URL}area`, { params: { province, city } });
export const getDistrict = ($axios, province, city, area) =>
  $axios.$get(`${INFO_URL}districts`, { params: { province, city, area } });
export const getPostalCode = ($axios, province, city, area) =>
  $axios.$get(`${INFO_URL}post-codes`, { params: { province, city, area } });
export const getTransaction = ($axios, id) => $axios.$get(`${GT_URL}payment-transactions/${id}`);
export const getPuzzleMiliarderList = ($axios, params) => $axios.$get(BUKAPOLY_URL, { params });
export const getPuzzleMiliarderGroupList = ($axios, params) =>
  $axios.$get(`${BUKAPOLY_URL}group-commissions`, { params });
export const updateStatusPuzzleMiliarderList = ($axios, code, status) =>
  $axios.$patch(`${BUKAPOLY_URL}${code}`, { status });
